var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file_preview_modal",attrs:{"dir":"rtl"}},[(_vm.is_loading)?_c('div',{staticClass:"loading"}):(_vm.has_error)?_c('p',{staticClass:"file_preview_error"},[_vm._v("שגיאה בטעינת הקובץ")]):_c('iframe',{staticClass:"file_preview_iframe",attrs:{"src":_vm.pdf_src,"width":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }